export function link(title, href) {
  return `[${linkTitle(title)}](${linkHref(href)})`;
}

export function linkMeasure(title, href) {
  const _title = linkTitle(title);
  const _href = linkHref(href);
  const preHref = '[' + _title + '](';
  return {
    markdown: preHref + _href + ')',
    hrefStart: preHref.length,
    hrefEnd: preHref.length + _href.length
  };
}

export function image(alt, imageHref) {
  return `![${linkTitle(alt)}](${linkHref(imageHref)})`;
}

export function linkTitle(title) {
  return title
    .replaceAll('\\', '\\\\')
    .replaceAll(']', '\\]')
    .replaceAll('[', '\\[')
    .replaceAll('<', '\\<')
    .replaceAll('>', '\\>');
}

export function linkHref(href) {
  return href
    .replaceAll('\\', '\\\\')
    .replaceAll('(', '\\(')
    .replaceAll(')', '\\)');
}
